import { CURRENCY_SYMBOLS, CURRENCIES } from 'common/constants/payment';

export const formatCurrency = (currency: string = CURRENCIES.GBP) => CURRENCY_SYMBOLS[currency];

export default (amount: number, currency: string = CURRENCIES.GBP) =>
  `${CURRENCY_SYMBOLS[currency]}${amount ? (amount / 100).toFixed(2) : 0}`;
